import { useExperimentStore } from '../store/experimentStore';
import { useUiStore } from '../store/uiStore';
import { useRef } from 'react';

export function useExperiment() {
    const { addVolume, resetExperiment, setLabStage, labStage, isBuretteFilled, isFlaskFilled } = useExperimentStore();
    const demoTimeoutRef = useRef<ReturnType<typeof setTimeout> | null>(null);

    const startDemo = () => {
        // Clear any existing demo sequence
        if (demoTimeoutRef.current) {
            clearTimeout(demoTimeoutRef.current);
        }

        // Always reset first to ensure a clean slate
        resetExperiment();
        
        let delay = 0;
        
        // 1. Fill Burette
        demoTimeoutRef.current = setTimeout(() => {
            setLabStage('fill-burette');
        }, delay);
        delay += 6000; // Animation takes ~5.8s

        // 2. Fill Flask
        demoTimeoutRef.current = setTimeout(() => {
            setLabStage('setup-flask'); // Trigger transition block
             // We need to set state to fill-flask so animation plays
             setTimeout(() => setLabStage('fill-flask'), 50); 
        }, delay);
        delay += 6000;

        // 3. Start Titration
        demoTimeoutRef.current = setTimeout(() => {
            setLabStage('titrate');
            runTitrationLoop(0);
        }, delay);
    };

    const runTitrationLoop = (currentVolume: number) => {
        let vol = currentVolume;

        const runDemoStep = () => {
            if (vol < 20) {
                vol += 1.0;
                addVolume(1.0);
                demoTimeoutRef.current = setTimeout(runDemoStep, 350);
            } else if (vol >= 20 && vol < 24.5) {
                vol += 0.1;
                addVolume(0.1);
                demoTimeoutRef.current = setTimeout(runDemoStep, 250);
            } else if (vol >= 24.5 && vol < 24.9) {
                vol += 0.1;
                addVolume(0.1);
                demoTimeoutRef.current = setTimeout(runDemoStep, 600);
            } else if (vol >= 24.9 && vol < 25.0) {
                vol += 0.1;
                addVolume(0.1);
                demoTimeoutRef.current = setTimeout(runDemoStep, 2000); // long pause at equivalence
            } else if (vol >= 25.0 && vol < 25.5) {
                vol += 0.1;
                addVolume(0.1);
                demoTimeoutRef.current = setTimeout(runDemoStep, 400);
            } else {
                // Demo done - Auto Trigger the Analysis Step
                if (demoTimeoutRef.current) clearTimeout(demoTimeoutRef.current);
                if (!useUiStore.getState().showResults) {
                    useUiStore.getState().toggleResults();
                }
            }
        };

        runDemoStep();
    };

    const stopDemo = () => {
        if (demoTimeoutRef.current) {
            clearTimeout(demoTimeoutRef.current);
        }
    };

    return { startDemo, stopDemo };
}
